/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ delivered: NonNullable<unknown>, unit: NonNullable<unknown>, returned: NonNullable<unknown>, returnable: NonNullable<unknown> }} Sales_Return_Line_SummaryInputs */

const vi_sales_return_line_summary = /** @type {(inputs: Sales_Return_Line_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã giao ${i?.delivered} ${i?.unit} · đã trả ${i?.returned} · còn trả được ${i?.returnable}`)
};

/**

* @param {Sales_Return_Line_SummaryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_line_summary = /** @type {((inputs: Sales_Return_Line_SummaryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Line_SummaryInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_line_summary(inputs)
});